export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7842.e13d49b6.jpg";